import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

/**
 * Admin: panel REST API (konta API, webhooki, logi, naruszenia limitów).
 * Backend: /v1/admin/rest-api/* (guard auth + adminAuth).
 */
@Injectable({ providedIn: 'root' })
export class AdminRestApiService {

    constructor(private http: HttpClient) { }

    public browseAccounts(params: { searchQuery?: string; currentPage?: number; itemsPerPage?: number }) {
        return this.http.post(API_HOST + 'admin/rest-api/accounts', params)
    }

    public browseWebhooks(params: { searchQuery?: string; currentPage?: number; itemsPerPage?: number }) {
        return this.http.post(API_HOST + 'admin/rest-api/webhooks', params)
    }

    public browseLogs(params: { searchQuery?: string; method?: string; statusCode?: number; statusClass?: string; type?: string; accountEmail?: string; apiAccountId?: string; currentPage?: number; itemsPerPage?: number }) {
        return this.http.post(API_HOST + 'admin/rest-api/logs', params)
    }

    public getOffenders() {
        return this.http.get(API_HOST + 'admin/rest-api/offenders')
    }

    public getStats() {
        return this.http.get(API_HOST + 'admin/rest-api/stats')
    }
}
